import React from 'react';

import { LocationObject } from 'shared/helpers/mapbox';
import useCart from 'hooks/use-cart';
import ROUTES from 'src/routes';
import routeTo from 'utils/route-to';

import { AddressAutocomplete } from 'components/address-autocomplete';
import { DesktopAddressComboboxDark } from './desktop-address-combobox-dark';

export function DesktopAddressComboboxDarkController(): JSX.Element {
  const Cart = useCart();
  function onSelect(location: LocationObject): void {
    Cart.updateAddress({ location });
    routeTo({ url: ROUTES.DISPENSARIES });
  }

  return (
    <AddressAutocomplete onSelect={onSelect}>
      <DesktopAddressComboboxDark />
    </AddressAutocomplete>
  );
}
